import { PermissionsEnum } from "@/auth/interfaces";
import { gridSize0, gridSizeMdLg12, ModulosEnumChoice, useCheckPermissions } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { useEffect } from "react";
import TableInformeInstalacionProgramadoPyl from "../tables/TableInformeInstalacionProgramadoPyl";

export default function InformeInstalacionProgramadasPagePyl() {

  useCheckPermissions(PermissionsEnum.api_view_agendamiento);

  //STATE

  const setFaseVenta = useDiccionarioMotivo().setFaseVenta;

  useEffect(() => {
    setFaseVenta(ModulosEnumChoice.AGENDAMIENTO);
  }, []);


  return (
    <SingleTableBoxScene
      title="Informe de Instalaciones Programadas y Resultados Diarios PYL"
      gridSizeTitle={gridSizeMdLg12}
      gridSizeBtnAccion={gridSize0}
    >
      <TableInformeInstalacionProgramadoPyl />
    </SingleTableBoxScene>
  )

}